import React, { useEffect, useState, useCallback } from 'react';
import idtap from './Icons/ID-tap.jpg';
import { MSCLogin } from '../../../services/MSC/MSCLogin';
import MSCrequest from '../../../services/MSC/MSCrequest';
import { useHistory } from 'react-router-dom';
import localRequest from '../../../services/LocalServer/localRequest';
import logger from '../../../services/LocalServer/logger';

export default function ScanPage(props) {
  const homepage = localStorage.getItem('homepage');
  const history = useHistory();
  // const machineID = localStorage.getItem('machineID');
  //use to prevent add event listener multitple times
  const { setuserName, first, setFirst } = props;

  const [success, setSuccess] = useState(0);
  const [error, setError] = useState(0);
  const [notvalid, setNotValid] = useState(false);

  useEffect(() => {
    if (success) {
      var interval = setInterval(() => {
        fetchCard();
      }, 2000);

      const fetchCard = () => {
        localRequest({
          method: 'get',
          url: `getCardInfo`,
        }).then(async (res) => {
          let uid = res?.data?.uid;
          logger(2, 'Get Card from reader = ' + uid);
          logger(2, 'Start Getting Person Info');
          // let uid = 'C7C69636';
          await MSCrequest({
            method: 'get',
            url: `${localStorage.getItem(
              'MSC_API'
            )}/reservation/v1/person-search?search=rfiduids==${uid}&includeAllAccounts=true`,
          })
            .then((res) => {
              if (res.data?.responsePayload?.content?.length > 0) {
                console.log(res.data?.responsePayload?.content[0].reservationId);
                localStorage.setItem(
                  'MSC_RES',
                  res.data?.responsePayload?.content[0].reservationId
                );
                setuserName(res.data?.responsePayload?.content[0].firstNameLastName);
                clearInterval(interval);
                logger(
                  2,
                  'Get Personal Info Successfully = ' +
                    res.data?.responsePayload?.content[0].firstNameLastName
                );
                history.push(homepage);
              } else {
                logger(2, 'Info of Card is not Valid =' + uid);
                setNotValid(true);
              }
            })
            .catch((e) => {
              logger(1, 'Error when sending card info to Otalio =' + JSON.stringify(e));
              console.log('eeeeeee', e);
              setNotValid(true);
            });
        });
      };
      // freshtoken every 4.6mins
      if (first) {
        setFirst(false);
        var reFreshToken = setInterval(async () => {
          logger(2, 'Start Refresh Token');
          await MSCrequest({
            method: 'post',
            url: `${localStorage.getItem('MSC_API')}/iam/v1/sso/refresh`,
            data: {
              refreshToken: localStorage.getItem('msc-refresh'),
            },
          })
            .then((res) => {
              logger(2, 'Successfully refresh token');
              localStorage.setItem('msc-token', res?.data?.responsePayload?.access_token);
              localStorage.setItem('msc-refresh', res?.data?.responsePayload?.refresh_token);
              // console.log('send refreshtoken success');
            })
            .catch(async (err) => {
              logger(1, 'Refresh Token Failed', JSON.stringify(err));
              await MSCLogin();
            });
        }, 280000);
      }
    }

    return () => {
      clearInterval(interval);
    };
  }, [success]);

  const test = async () => {
    // history.push(`/machineUI/out-of-order/${machineID}`);
  };

  const getInfo = async () => {
    let wrong = false;
    const b = error + 1;
    logger(2, 'Start Getting Other Info1');
    await MSCrequest({
      method: 'get',
      url: `${localStorage.getItem(
        'MSC_API'
      )}/metadata/v1/lookup-values?search=code==${localStorage.getItem('MSC_EXCODE')}`,
    })
      .then((res) => {
        console.log('MSC_VENDOR', res.data?.responsePayload?.content[0].entityId);
        if (res.data?.responsePayload?.content?.length > 0) {
          logger(2, 'Getting Other Info Successfully');
          localStorage.setItem('MSC_VENDOR', res.data?.responsePayload?.content[0].entityId);
        } else {
          logger(1, 'Getting Other Info1 Error');
          wrong = true;
        }
      })
      .catch((e) => {
        logger(1, 'Getting Other Info1 Error');
        wrong = true;
      });
    logger(2, 'Start Getting Other Info2');
    await MSCrequest({
      method: 'get',
      url: `${localStorage.getItem(
        'MSC_API'
      )}/device-manager/v1/client-devices/workstation-data/${localStorage.getItem('MSC_MAC')}`,
    })
      .then((res) => {
        console.log('MSC_WORKSTATION', res.data?.responsePayload?.workstationId);
        console.log('MSC_RVC', res.data?.responsePayload?.rvcId);
        if (res.data?.responsePayload?.workstationId) {
          logger(2, 'Start Getting Other Info2 Successfully');
          localStorage.setItem('MSC_WORKSTATION', res.data?.responsePayload?.workstationId);
          localStorage.setItem('MSC_RVC', res.data?.responsePayload?.rvcId);
        } else {
          logger(1, 'Getting Other Info2 Error');
          wrong = true;
        }
      })
      .catch((e) => {
        logger(1, 'Getting Other Info2 Error');
        wrong = true;
      });

    if (wrong) {
      setError(b);
    } else {
      setError(0);
    }
  };

  useEffect(async () => {
    if (notvalid) {
      setTimeout(() => {
        setNotValid(false);
      }, 5000);
    }
  }, [notvalid]);

  useEffect(async () => {
    localStorage.removeItem('MSC_RES');
    setuserName('');

    let success = await MSCLogin();
    setSuccess(success);
    if (!success) {
      setError(1);
    } else {
      getInfo();
    }
  }, []);

  useEffect(async () => {
    console.log('error', error);
    if (error && error < 4) {
      setTimeout(async () => {
        const success = await MSCLogin();
        setSuccess(success);
        if (!success) {
          const b = error + 1;
          setError(b);
        } else {
          getInfo();
        }
      }, 30000);
    }
  }, [error]);

  // useEffect(async () => {
  //   console.log(error);
  // }, [error]);

  return success ? (
    <div className="category-container" id="scanpage" style={{ background: 'rgb(235, 235, 235)' }}>
      <div
        style={{ paddingTop: '400px', color: 'rgb(36,86,135)', background: 'rgb(235, 235, 235)' }}
      >
        {notvalid ? (
          <div>
            <div style={{ fontWeight: 'bold', fontSize: '100px' }} onClick={test}>
              ERROR!
            </div>
            <div
              style={{
                fontWeight: 'bold',
                fontSize: '55px',
                marginBottom: '30px',
                marginTop: '10px',
              }}
              // onClick={getInfo}
            >
              The card is invalid, Please try again later.
            </div>
          </div>
        ) : (
          <div>
            <div style={{ fontWeight: 'bold', fontSize: '100px' }} onClick={test}>
              Welcome!
            </div>
            <div
              style={{
                fontWeight: 'bold',
                fontSize: '55px',
                marginBottom: '30px',
                marginTop: '10px',
              }}
              // onClick={getInfo}
            >
              To begin please tap your ID
            </div>
          </div>
        )}

        <img src={idtap} alt="i2" width={1000} />
      </div>
    </div>
  ) : (
    <div className="category-container" style={{ background: 'rgb(235, 235, 235)' }}>
      <div style={{ paddingTop: '400px', color: 'rgb(36,86,135)' }}>
        <div style={{ fontWeight: 'bold', fontSize: '100px' }} onClick={test}>
          {error ? `Network Error` : `Initializing Otalio...`}
        </div>
      </div>
    </div>
  );
}
